import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const WrappedReportRepository = RepositoryFactory.get(('ReportRepository'))['WrappedReportRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(WrappedReportRepository)

export const STORE_MODULE_NAME = 'report_wrapped';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
        isDownloadReportModalActive: false,
        downloadReportModalData: {}
    },
    getters: {},
    mutations: {
        SET_IS_DOWNLOAD_REPORT_MODAL_ACTIVE(state, val) {
            state.isDownloadReportModalActive = val
        },

        SET_DOWNLOAD_REPORT_MODAL_DATA(state, val) {
            state.downloadReportModalData = val
        },
    },
    actions: {
        fetch: get,
        generate_download ({ commit }, ctx) {
            const {id, data} = ctx
            return new Promise((resolve, reject) => {
                WrappedReportRepository.generate_download(id, data)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error))
            })
        },
    },
}
